import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'components/organisms/team-name-stacking/actions';
import SetMaxForAllTeamsSettings from './set-max-for-all-teams-settings';

class Settings extends Component {
    handleCheckAll(isEnabled) {
        this.props.dispatch(Action.setAllTeamOptionsEnabledStatus(isEnabled));
    }

    isAllTeamsChecked() {
        const {stacking} = this.props;
        const teamOptions = stacking.getItems();

        if (isEmpty(teamOptions)) {
            return stacking.getDefaultTeamOptionsEnabledStatus();
        }

        for (let teamOption of teamOptions) {
            if (teamOption.enabled !== true) {
                return false;
            }
        }

        return true;
    }

    render() {
        const isAllTeamsChecked = this.isAllTeamsChecked();

        return (
            <div className="team-limits-top">
                <button
                    onClick={() => this.handleCheckAll(!isAllTeamsChecked)}
                    type="button"
                    className="checkbox-btn-block"
                >
                    <span className={`checkbox-btn ${isAllTeamsChecked ? 'active' : ''}`} />
                    <span className="checkbox-btn-text">Check All Teams</span>
                </button>
                <SetMaxForAllTeamsSettings />
            </div>
        );
    }
}

function mapStatesToProps(state) {
    return {
        stacking: state.teamNameStacking,
    };
}

export default connect(mapStatesToProps)(Settings);
